export default __webpack_public_path__ + "static/media/iphone-background.86f5c0b7.png";